import React from 'react';
import { motion } from 'framer-motion';
import { ShoppingCart, CreditCard, Truck, ShieldCheck } from '@phosphor-icons/react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

const WebshopProcess = () => {
  const { t } = useTranslation();

  const processSteps = [
    {
      icon: ShoppingCart,
      title: t('webshopProcess.discovery.title'),
      description: t('webshopProcess.discovery.description'),
    },
    {
      icon: CreditCard,
      title: t('webshopProcess.design.title'),
      description: t('webshopProcess.design.description'),
    },
    {
      icon: Truck,
      title: t('webshopProcess.development.title'),
      description: t('webshopProcess.development.description'),
    },
    {
      icon: ShieldCheck,
      title: t('webshopProcess.launch.title'),
      description: t('webshopProcess.launch.description'),
    }
  ];

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        ease: [0.16, 1, 0.3, 1]
      }
    }
  };

  return (
    <section className="bg-gray-50 py-24">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold font-heading text-gray-900 mb-6">
            {t('webshopProcess.title')}
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            {t('webshopProcess.subtitle')}
          </p>
        </div>

        <motion.div
          className="grid md:grid-cols-2 lg:grid-cols-4 gap-8"
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.3 }}
        >
          {processSteps.map((step, index) => (
            <motion.div
              key={index}
              className="relative group"
              variants={itemVariants}
            >
              <div className="bg-white rounded-xl p-8 shadow-sm border border-gray-100 hover:shadow-md transition-all duration-300 transform hover:-translate-y-1">
                <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-gray-100 text-gray-600 mb-6 group-hover:bg-gray-200 transition-colors duration-300">
                  <step.icon size={32} weight="thin" />
                </div>
                
                <div className="absolute top-4 right-4 bg-gray-200 text-gray-700 text-sm font-medium px-3 py-1 rounded-full">
                  {index + 1}
                </div>
                
                <h3 className="text-xl font-bold text-gray-900 mb-4">
                  {step.title}
                </h3>
                <p className="text-gray-600 leading-relaxed">
                  {step.description}
                </p>
              </div>
            </motion.div>
          ))}
        </motion.div>

        <div className="text-center mt-16">
          <Link to="/start-your-project" className="inline-flex items-center gap-2 text-lg font-semibold text-gray-700 bg-white px-8 py-4 rounded-full shadow-sm border border-gray-200 hover:shadow-md transition-all duration-300">
            {t('webshopProcess.cta')}
          </Link>
        </div>
      </div>
    </section>
  );
};

export default WebshopProcess;
